<app-header></app-header>
<div style ="background:#26abe3" class="header-search-bar">
  <div class="container">
    <div class="header-search-bar-main">
      <form #searchDoctor="ngForm" (ngSubmit)="searchDoctorForm(searchDoctor)">
          <div class="row">
              <div class="col-md-6 col-lg-4">
                  <div class="ng-autocomplete1 form-group-img">
                      <ng-autocomplete 
                        [data]="cities"
                        placeHolder ="Select City Name"
                        [initialValue] ="object.city"
                        [searchKeyword]="object.city"
                        (selected)='selectEvent($event,searchDoctor)'
                        (inputChanged)='onChangeSearch($event)'
                        (inputFocused)='onFocused($event)'
                        [itemTemplate]="itemTemplate"
                        [notFoundTemplate]="notFoundTemplate"
                        name="city" [(ngModel)]="object.city"
                        >                                 
                      </ng-autocomplete>
                       
                      <ng-template #itemTemplate let-item>
                      <a [innerHTML]="item"></a>
                      </ng-template>
                       
                      <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="notFound"></div>
                      </ng-template>

                      <span class="c-omni-searchbox__button-container">
                        <span class="c-omni-searchbox__button c-omni-searchbox__button" data-qa-id="current_location">
                            <i class="fa fa-map-marker" aria-hidden="true"></i>
                          <span (click)="detectLocation(searchDoctor)" *ngIf="searchDoctor.value.city!=currentCity" class="c-omni-searchbox__button__text">
                            Detect </span>
                          </span>
                        </span>
                      <!-- <i class="fa fa-map-marker" aria-hidden="true"></i> -->
                      </div>
                  <!-- <div class="form-group-img">
                      <select (change)="searchDoctorForm()"  [(ngModel)]="object.city"  name="city" class="form-control">
                        <option value=''>Choose City...</option>
                          <option [hidden]="city==''" *ngFor="let city of cities" [value]="city">{{ city }}</option>


                      </select>
                      <i class="fa fa-map-marker" aria-hidden="true"></i>
                  </div> -->
              </div>
              <div class="col-md-6  col-lg-6">
                  <div class="form-group-img form-group-btn">
                      <input  [(ngModel)]="object.name" name="name" type="text" class="form-control" [placeholder]="searchText">
                      <i class="fa fa-search" aria-hidden="true"></i>
                      <input type="submit" class="btn-style" value="Search">
                  </div>
              </div>
              <!-- <div class="col-md-12 col-lg-2">
                  <div class="form-group-btn">
                     
                      
                  </div>
              </div> -->
          </div>
      </form>
  </div>
  </div>
</div>
<!-- </header> -->
<!--<section class="pharmacy hospitals padd-row galleryBg scrollHeightCss" #myScrollContainer (scroll)="onScroll()">-->
<section class="pharmacy hospitals padd-row search-results"
         infiniteScroll
         [infiniteScrollDistance]="2"
         [infiniteScrollThrottle]="50"
         (scrolled)="onScroll(searchDoctor)">
  <div class="container">
    <div class="hosptials-main">
      <div class="row">

        <div *ngFor="let pharmacy of pharmacyList" class="col-md-6 col-lg-4">
          <div class="hospitals-box card">
            <div class="hospitals-box-img">
              <img [src]="pharmacy.profilePicture" alt="image">
              <div class="offer-sticker" *ngIf="pharmacy.discount!=0"> {{ pharmacy.discount }}% off</div>
            </div>
            <div class="hospitals-box-cnt">
              <div class="hospitals-box-cnt-heading">
                <div class="d-md-flex">
                  <div class="hos-box-cnt-heding-lft" style="width: 100%">
                    <h4> {{ pharmacy.name.slice(0,20) }}  {{ pharmacy.name.length>20 ? '...' : '' }}  </h4>
                     <p> {{ pharmacy.address.slice(0,35) }}  {{ pharmacy.address.length>35 ? '...' : '' }} </p>
                  </div>
                  <div class="doctor-box-rating">
                    <i class="fa fa-star" aria-hidden="true"></i>
                    <span>  {{ !pharmacy?.averageRatings ? 0 : pharmacy?.averageRatings }} /5  </span>
                      <p> {{ !pharmacy?.review?.length ? 0 : pharmacy.review.length }}  Reviews</p>
                    <p></p>
                  </div>
                </div>
              </div>
              <div class="hos-box-btm-cnt">
                <p class="hos-box-bmt-info">
                  <span> Registered {{isBloodbank ? 'Blood Bank' : 'Pharmacy'}} 
                    <img width="30px" height="30px" src="assets/images/bluetick.png"> | <a [routerLink]="null"> 
                      {{ pharmacy?.phoneNo }} </a> 
                    </span>
                </p>
                <div class="hos-box-btns">
                  <a [routerLink]="['/pharmacy/detail/'+pharmacy._id]" class="btn-style" *ngIf="!isBloodbank"> Upload Prescription </a>
                  <a [routerLink]="['/blood/detail/'+pharmacy._id]" class="btn-style" *ngIf="!!isBloodbank"> View Detail </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

<!--      <button class="btn btn-primary pull-right" (click)="skip = skip +1;getPharmacyList()">Load more...</button>-->

    </div>
    <!-- <div class="doctors-pagination text-center">
        <ul>
            <li> Previous </li>
            <li class="current-pagi"> 1 </li>
            <li> <a href="javascript://"> 2 </a> </li>
            <li> <a href="javascript://"> 3 </a> </li>
            <li> <a href="javascript://"> 4 </a> </li>
            <li> <a href="javascript://" class="next"> Next </a> </li>
        </ul>
    </div> -->
  </div>

</section>

<!--- End of doctors -->
<ngx-spinner></ngx-spinner>
